import { useEffect, useState } from 'react'
import { subscribeUndo, runUndo, dropUndo } from '../lib/undoDelete'

// "Deleted X - Undo (10)" after a delete (src/lib/undoDelete.js). Bottom centre, above the phone tab bar, under the
// floating AI button (z-index 1050 < 1100) so it never covers it.
export default function UndoToast() {
  const [list, setList] = useState([])
  const [now, setNow] = useState(Date.now())
  const [err, setErr] = useState('')
  useEffect(() => subscribeUndo(l => setList([...l])), [])
  useEffect(() => {
    if (!list.length) return
    const t = setInterval(() => setNow(Date.now()), 250)
    return () => clearInterval(t)
  }, [list.length])
  useEffect(() => { if (!err) return; const t = setTimeout(() => setErr(''), 6000); return () => clearTimeout(t) }, [err])
  if (!list.length && !err) return null
  const undo = async id => { try { await runUndo(id) } catch (e) { setErr('Could not undo: ' + (e.message || e)) } }
  return (
    <div className="hc-undo" role="status" aria-live="polite">
      <style>{`
        .hc-undo { position: fixed; left: 50%; transform: translateX(-50%); bottom: 22px; z-index: 1050; display: flex; flex-direction: column; gap: 8px; max-width: calc(100vw - 32px); }
        @media (max-width: 1023px) { .hc-undo { bottom: calc(70px + env(safe-area-inset-bottom)); } }
        .hc-undo-row { display: flex; align-items: center; gap: 12px; background: #16233a; color: #e7edf6; border-radius: 10px; padding: 10px 12px 10px 16px; box-shadow: 0 8px 24px rgba(0,0,0,.35); font-size: 13px; }
        .hc-undo-row button { background: none; border: 1px solid rgba(255,255,255,.25); color: #f0c766; font-weight: 700; font-size: 13px; padding: 5px 12px; border-radius: 7px; cursor: pointer; font-family: inherit; }
      `}</style>
      {list.map(e => (
        <div key={e.id} className="hc-undo-row">
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>Deleted: {e.label}</span>
          <button onClick={() => undo(e.id)}>Undo ({Math.max(0, Math.ceil((e.until - now) / 1000))})</button>
          <button onClick={() => dropUndo(e.id)} aria-label="Close" style={{ border: 'none', color: '#8fa1bb', padding: '5px 4px' }}>{'×'}</button>
        </div>
      ))}
      {err && <div className="hc-undo-row" style={{ background: '#5a1f24' }}>{err}</div>}
    </div>
  )
}
